import LoadingSpinner from "@/components/molecules/loading-spinner/loading-spinner-page";

export const loadPageWithLoader = (component) => {
  return defineAsyncComponent({
    loader: component,
    loadingComponent: LoadingSpinner,
    delay: 50
  })
}
